import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Unauthorized from "./Unauthorized";

// For routes that can only be accessed by Plumb Ditch users (and admins/developers)
const ALLOWED_ROLES = ["Administrator", "Developer", "Plumb Ditch"];

const PlumbDitchGuard = ({ children }) => {
  const { user, isAuthenticated } = useAuth0();

  if (!user) return <Unauthorized />;

  const roles = user[`${process.env.REACT_APP_AUDIENCE}/roles`];
  let hasAccess = false;
  if (roles && roles.filter((x) => ALLOWED_ROLES.includes(x)).length > 0) {
    hasAccess = true;
  }

  if (!isAuthenticated || !hasAccess) {
    return <Unauthorized />;
  }

  return children;
};

export default PlumbDitchGuard;
